import React, { FC } from 'react'
import cn from 'classnames'
import { useStore } from 'store'
import { observer } from 'mobx-react'
import { Control, Controller, FieldErrors } from 'react-hook-form'

import styles from './styles.module.scss'

interface IProps {
  name: string;
  placeholder?: string;
  disabled?: boolean,
  control: Control<any>;
  errors?: FieldErrors<any>,
  limit?: number,
}

export const TextareaField: FC<IProps> = ({ name, placeholder, control, errors, disabled, limit }) => {
  return (
    <Controller
      name={name}
      control={control}
      defaultValue=""
      render={({ field }) => {
        const { value } = field
        const length = value.length

        return (
          <div className={styles.textareaBox}>
            <textarea  {...field}
                       disabled={disabled}
                       id={name}
                       placeholder={placeholder}
                       className={cn(styles.textarea, {
                         [styles.textareaError]: errors && errors[name]
                       })}/>
            <div className={cn(styles.noteLength, {
              [styles.noteLengthOverMax]: length > (limit ? limit : 500)
            })}>
              {length}/{limit ? limit : 500}
            </div>
          </div>
        )
      }}
    />

  )
}
